module.exports = __webpack_public_path__ + "img/24.9829b03b.png";